import { Overview } from 'pages/seo/club/Overview';

import { useLayoutData } from './layout';

const FootballClub = () => {
  const club = useLayoutData();
  const seasonStartYear = club.domesticLeague?.seasons.slice(-1)[0]?.startYear;

  return <Overview seasonStartYear={seasonStartYear} />;
};

export default FootballClub;
